<template>
  <v-app>
    <v-main class="client-login-background">
      <v-container fluid class="fill-height">
        <v-row align="center" justify="center">
          <v-col cols=12 xs="12" md="8" lg="4">
            <v-card class="elevation-12">
              <v-toolbar height="150" flat>
                <v-spacer></v-spacer>
                <div class="client-login-logo-wrap">
                  <img :src="logoPrimary" alt="Kobe" />
                </div>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <p class="title text-center">Advertiser Login</p>
                <v-form>
                  <v-text-field
                    v-model="email"
                    :error-messages="emailErrors"
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                    prepend-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    :error-messages="passwordErrors"
                    @input="$v.password.$touch()"
                    @blur="$v.password.$touch()"
                    @keyup.enter="checkCreds()"
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    type="password"
                  ></v-text-field>
                </v-form>
                <v-btn block @click="checkCreds()" color="secondary">Login</v-btn>
                <v-flex text-center xs12>
                  <br>
                  <a href="/forgot-password">Forgot password?</a>
                </v-flex>
                <v-divider></v-divider>
                <p class="title text-center">
                  For Influencers <br>
                    <v-btn
                      depressed
                      dark
                      to="login"
                    >
                      Go to Influencer Login
                    </v-btn>
                </p>
                <v-divider></v-divider>
                <p class="text-left">
                  By logging in, you confirm that you have read the
                  <a
                    href="https://www.getkobe.com/website-terms-use/"
                    target="_blank"
                  >terms and conditions</a> , that you understand them and that you agree to be bound by them.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer dark height="auto" color="#1A1A1A">
      <v-row row wrap white--text text-center>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <u>Singapore</u>
            <br />Contact:
            <a href="tel:+6562555662">6255 5662</a> /
            <a href="mailto:creator@getkobe.com">creator@getkobe.com</a>
            <br />51 Goldhill Plaza #14-01 Singapore 308900
          </p>
        </v-flex>
        <v-flex md4 xs12>
          <p class="white--text text-center">
            <br />Website
            <a href="https://getkobe.com/website-terms-use">Terms of Use</a> and
            <a href="https://getkobe.com/website-privacy-policy">Privacy Policy</a>.
            <br />
            All Rights Reserved &copy; 2016-{{year}} Kobe Global Technologies Pte Ltd
          </p>
        </v-flex>
        <v-flex md4 xs12>
          <p class="white--text text-center mb-0 pt-2">
            Patent: <a href="https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1" target="_blank"> KOBE 11201807777W ℗ </a>
          </p>
        </v-flex>
      </v-row>
    </v-footer>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="#A3FF12"
      width.number="90"
      height.number="90"
    />
  </v-app>
</template>

<script>
import api from '@/api';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'ClientLogin',
  mixins: [validationMixin],
  components: {
    Loading
  },
  data(router) {
    return {
      year: new Date().getFullYear(),
      section: 'Login',
      loading: false,
      logoPrimary: require('@/assets/Kobe Logo Blue.png'),
      email: '',
      password: '',
      response: ''
    };
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  methods: {
    checkCreds() {
      const { email, password } = this;

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      /* Making API call to authenticate a user */
      api
        .request('post', '/api/v1/users/login', false, { email, password })
        .then(response => {
          this.toggleLoading();

          var userData = response.data;
          var jwtToken = userData.jwtToken;

          // Remove jwt token from user data
          delete userData.jwtToken;

          /* Setting user in the state and caching record to the localStorage */
          var token = 'Bearer ' + jwtToken;

          this.$store.commit('SET_USER', userData);
          this.$store.commit('SET_TOKEN', token);
          // To-Do -> Fetch notifications data from server and assign here
          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(userData));
            window.localStorage.setItem('token', token);
          }

          this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : '/');
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING');
          // Show error alert
          // if no data in response, show the default error message
          this.$swal({
            title: 'Error',
            text: error.response.data.err || 'Please enter your Username & Password correctly! (or) Contact us for help',
            type: 'error'
          });

          this.response = error;
          this.toggleLoading();
        });
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    resetResponse() {
      this.response = '';
    }
  },
  computed: {
    // Form Validation Errors
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  }
};
</script>

<style>
.v-footer {
  padding-top: 50px!important;
  padding-bottom: 50px!important;
  height: 'auto';
}
.client-login-background {
    background: linear-gradient(-45deg, #1a1a1a, #6a0dad, #3f3fff, #a3ff12);
    background-size: 400% 400%;
    animation: gradient 15s ease infinite;
}

.client-login-logo-wrap {
  width: min(260px, 72vw);
  max-width: 260px;
  line-height: 0;
}

.client-login-logo-wrap img {
  display: block;
  width: 100%;
  height: auto;
}

@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
</style>



// WEBPACK FOOTER //
// ClientLogin.vue?7ddf3306